import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 3D869F3A-8C3E-4ECB-829E-7785230FA680
 * name account-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-alert.svg
 * tags
 * - Account / User 
 * - Alert / Error 
 */
export const AccountAlertIcon = createSvgIcon(<><path d="M10 4A4 4 0 0 1 14 8A4 4 0 0 1 10 12A4 4 0 0 1 6 8A4 4 0 0 1 10 4M10 14C14.42 14 18 15.79 18 18V20H2V18C2 15.79 5.58 14 10 14M20 12V7H22V13H20M20 17V15H22V17H20Z" /></>, 'AccountAlertIcon');
export default AccountAlertIcon